export const pt = {
  welcome: 'Bem-vindo',
  logout: 'Sair',
  settings: 'Configurações',

  days: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
  today: 'Hoje',
  yesterday: 'Ontem',

  THEME: {
    DARK: 'Escuro',
    LIGHT: 'Claro',
  },

  PLACEHOLDER: {
    SEARCH_PLACEHOLDER: 'Pesquisar...',
    SELECT_OPTION: 'Selecione uma opção...',
    SELECT_STATUS: 'Selecionar status...',
    CHOOSE_STATUS: 'Escolher status...',
    LOCATION: 'Digite uma cidade, endereço ou local...',
    DESCRIPTION: 'Descrição do incidente',
    AI_DESCRIPTION:
      'Descreva o que aconteceu, onde e quando — ex.: Houve um pequeno incêndio na sala elétrica perto da Balestier Road, Novena.',
    LOCATION_DESCRIPTION: 'Detalhes adicionais sobre o local',
    VALIDATING: 'Validando...',
    GENERATING: 'Gerando...',
  },

  CHAT_PANEL: {
    SEARCH_PLACEHOLDER: 'Buscar...',
    NO_MESSAGES_YET: 'Ainda sem mensagens',
    IS_SPEAKING: 'está falando...',
    ONLINE: 'online',
    OFFLINE: 'offline',
    TRANSCRIBING: 'Transcrevendo...',
    NO_CHAT_FOUND: 'Nenhum chat encontrado',
    NO_CHAT_SELECTED_TITLE: 'Nenhum chat selecionado',
    NO_CHAT_SELECTED_DESCRIPTION: 'Selecione um usuário ou grupo na barra lateral para começar a conversar',
    INPUT_PLACEHOLDER_DEFAULT: 'Escreva uma mensagem...',
    INPUT_PLACEHOLDER_WITH_ATTACHMENT: 'Adicione uma legenda...',
    IS_TALKING: 'está falando...',
    PTT_ACTIVE: 'PTT Ativo – falando...',
    PTT_LOCKED: 'PTT Bloqueado – Clique para liberar',
    PTT_SLIDE_HINT: 'Deslize para cima para bloquear',
    PTT_RELEASE_AND_SEND: 'Soltar & Enviar',
    ATTACHED_FILES_TITLE: 'Arquivos anexados',
    FAILED_TO_TRANSCRIBE_AUDIO: 'Falha ao transcrever áudio',
    NO_CHAT_MESSAGE: 'Nenhuma mensagem de chat',
    FALLBACK_MESSAGE: 'Para iniciar um chat, digite sua mensagem ou use o recurso PTT/PTV.',
    INCOMING_VIDEO_CALL: 'Chamada PTV entrando...',
    SOMETHING_WENT_WRONG: 'Algo deu errado',
    ERROR: 'Erro:',
    NO_MESSAGES_FOUND_FOR: 'Nenhuma mensagem encontrada para',
    SYSTEM_MESSAGE: 'Mensagem do sistema',
    GROUP: 'grupo',
    AUDIO: 'áudio',
    VIDEO: 'vídeo',
    FILE: 'arquivo',
    ME: 'eu',
    IMAGE: 'imagem',
    TEXT: 'texto',
    CHAT: 'chat',
    NONE: 'nenhum',
    PROFILE: 'perfil',
    SEARCH: 'buscar',
    COMPLETED: 'concluído',
    RESOLVED: 'resolvido',
    USER_EMAIL_DOMAIN: '@widebridgecloud.com',
    UNKNOWN: 'Desconhecido',
    THEM: 'eles',
    HAS_ACCEPTED_THE_INCIDENT: 'aceitou o incidente',
    INCIDENT_HAS_BEEN_UPDATED: 'O incidente foi atualizado',
    INCIDENT_HAS_BEEN_RESOLVED: 'O incidente foi resolvido',
    YOU_HAVE_JOINED_THE_GROUP: 'Você entrou no grupo',
  },

  PROFILE_PANEL: {
    MEMBERS_LABEL: 'membros',
    GROUP_MEMBERS_TITLE: 'Membros do grupo',
    USERNAME_LABEL: 'Nome de usuário',
    EMAIL_LABEL: 'E-mail',
    MEMBER_FALLBACK_NAME: 'Membro',
    MEMBER_FALLBACK_ID: 'Membro',
  },

  PTT: {
    AUDIO: {
      FILENAME_PREFIX: 'ptt-audio-',
      FILE_TYPE: 'audio/webm',
      FILE_EXTENSION: '.webm',
    },
    MESSAGES: {
      START_RECORDING: 'Gravação PTT iniciada para {{userName}}',
      STOP_RECORDING: 'Áudio PTT enviado para {{userName}}',
      NO_AUDIO_DATA: 'Nenhum dado de áudio recebido do SDK',
      TRANSCRIPTION_SUCCESS: 'Transcrição de áudio concluída',
      TRANSCRIPTION_FAILED: 'Transcrição falhou, enviando áudio sem texto',
    },
    TRANSCRIPTION: {
      MODEL: 'whisper-1',
      LANGUAGE: 'pt',
      RESPONSE_FORMAT: 'text',
    },
  },

  CHAT_WINDOW: {
    SEARCH_IN: 'Pesquisar em',
    YOUR_PROFILE: 'Seu perfil',
    VIEW_PROFILE: 'Ver perfil',
    PIN_CHAT: 'Fixar conversa',
    UNPIN_CHAT: 'Desafixar conversa',
    MUTE_CHAT: 'Silenciar conversa',
    UNMUTE_CHAT: 'Ativar som da conversa',
  },

  DASHBOARD: {
    INCIDENTS: 'incidentes',
    INCIDENTS_NO_DATA: 'Para criar um incidente, clique no botão "+ Criar Incidente"',
    RESPONDERS: 'socorristas',
    RESPONDERS_NO_DATA: 'Nenhum socorrista encontrado.',
    CHAT: 'bate-papo',
    ALERTS: 'alertas',
    ALERTS_NO_DATA: 'Nenhum alerta gerado pelo sistema.',
    UPDATES: 'atualizações',
    UPDATES_NO_DATA: 'Nenhuma atualização sobre o incidente ou socorristas.',
    NEW_MESSAGE_FROM: 'Nova mensagem de',
    INCIDENT_UPDATED_BY: 'Incidente atualizado por',
    NEW_INCIDENT_CREATED_BY: 'Novo incidente criado por',
    PROFILE: 'perfil',
    SUMMARY: 'resumo',
    GENERATING_SUMMARY: 'gerando resumo...',
  },

  INCIDENTS_PANEL: {
    INCIDENT_NAME: 'Nome do incidente',
    INCIDENT_TYPE: 'Tipo de incidente',
    ASSIGNEES: 'responsável(is)',
    SEVERITY: 'gravidade',
    STATUS: 'status',
    STATUS_HISTORY: 'Histórico de status',
    SHOW: 'Mostrar',
    SHOW_LESS: 'Mostrar menos',
    MORE: 'mais',
    PTT: 'PTT',
    LOCATION: 'localização',
    SEVERITY_CRITICAL: 'crítico',
    SEVERITY_HIGH: 'alto',
    SEVERITY_MEDIUM: 'médio',
    SEVERITY_LOW: 'baixo',
    SEVERITY_MINIMAL: 'mínimo',
    REPORTED_DATE_TIME: 'Data e hora do relato',
    REPORTED_NAME: 'Nome do relator',
    DESCRIPTION: 'descrição',
    RESPONDERS: 'respondente(s)',
    ATTACHMENTS: 'anexos',
    LOCATION_DESCRIPTION: 'descrição do local',
    NO_RESPONDERS_ASSIGNED: 'Nenhum respondente atribuído ao incidente.',
    CREATE_INCIDENT: 'Criar incidente',
    EDIT_INCIDENT: 'Editar incidente',
    SELECT_RESPONDERS: 'Selecionar respondentes',
    COMPLETE: 'Concluir',
    CANCEL: 'Cancelar',
    SAVE: 'Salvar alterações',
    NO: 'Não',
    DATA_FOUND: 'Dados encontrados',
    NO_OPTIONS: 'Nenhuma opção disponível',
    AI_ASSISTANCE: 'Assistência de IA',
  },
  TAB_KEYS: {
    ALL: 'todos',
    UNREAD: 'não lido',
    ACTIVE: 'ativo',
    CLOSED: 'fechado',
    AVAILABLE: 'disponível',
    OFFLINE: 'offline',
    TAB_VALUE_UNACKNOWLEDGED: 'não reconhecido',
    TAB_VALUE_CREATED: 'criado',
    TAB_VALUE_PROGRESS: 'em andamento',
    TAB_VALUE_RESOLVED: 'resolvido',
  },

  UPDATES_PANEL: {
    UPDATES: 'Atualizações',
    MARK_AS_READ: 'Marcar tudo como lido',
    ALL: 'Todos',
    UNREAD: 'Não lidos',
    ALL_KEY: 'all',
    UNREAD_KEY: 'unread',
    NO_NOTIFICATIONS: 'Sem notificações',
    NO_UNREAD_NOTIFICATIONS: 'Sem notificações não lidas',
    UPDATE_STATUS: 'Atualizar status:',

    // Notification titles
    NEW_INCIDENT_TITLE: 'Novo Incidente',
    UPDATE_TITLE: 'Atualização',

    CREATED_AT: 'criado em',

    // Status labels
    STATUS_CLOSED: 'Fechado',
    STATUS_IN_PROGRESS: 'Em Andamento',

    // Change descriptions
    STATUS_CHANGE: 'Status',
    SEVERITY_CHANGE: 'Gravidade',
    TYPE_CHANGE: 'Tipo',
    DESCRIPTION_UPDATED: 'Descrição atualizada',
    RESPONDERS_ADDED: 'respondedor(es) adicionado(s)',
    RESPONDERS_REMOVED: 'respondedor(es) removido(s)',
    RESPONDERS_UPDATED: 'Respondedores atualizados',
    LOCATION_CHANGED: 'Localização alterada',
    UPDATED_DEFAULT: 'Atualizado',

    //Time
    UNKNOWN: 'Desconhecido',
    JUST_NOW: 'agora mesmo',
    MINUTES_AGO: 'há {{count}} min',
    MINUTES_AGO_plural: 'há {{count}} mins',
    HOURS_AGO: 'há {{count}} hora',
    HOURS_AGO_plural: 'há {{count}} horas',
    DAYS_AGO: 'há {{count}} dia',
    DAYS_AGO_plural: 'há {{count}} dias',

    // Default values
    DEFAULT_TYPE: 'Incidente',
    UNKNOWN_LOCATION: 'Localização desconhecida',
  },

  MAP_VIEW: {
    INCIDENT_TOOLTIP: {
      INCIDENTTYPE: 'Tipo de Incidente',
      REPORTEDDATE: 'Data Reportada',
      SEVERITY: 'Gravidade',
      STATUS: 'Status',
      RESPONDERS: 'Socorristas',
      NO_RESPONDERS: 'Nenhum socorrista disponível',
    },
    INCIDENT_CLUSTER_TOOLTIP: {
      INCIDENTS: 'Incidentes',
      MORE: 'mais...',
    },
    MAP_FILTER: {
      VIEW_MODE: 'Modo de Visualização',
      DEFAULT: 'Padrão',
      SATELLITE: 'Satélite',
      FILTER_BY: 'Filtrar Por',
      ALL: 'todos',
      ACTIVE: 'Ativo',
      COMPLETED: 'Concluído',
      RESPONDERS: 'Socorristas',
      AVAILABLE: 'disponível',
    },
  },

  FALLBACK_SCREEN: {
    NO: 'Não',
    DATA_FOUND: 'Dados Encontrados',
    CREATE_INCIDENT: 'Criar Incidente',
    NO_AVAILABLE_RESPONDER_FOUND: 'Nenhum socorrista disponível encontrado',
  },
  PERMISSION_DIALOG: {
    MICROPHONE: {
      TITLE: 'Acesso ao microfone necessário',
      DESCRIPTION: 'Este aplicativo precisa de acesso ao seu microfone para funcionar corretamente.',
      INSTRUCTION: 'Por favor, conceda permissão ao microfone para continuar usando o aplicativo.',
      BUTTON_LABEL: 'Conceder permissão ao microfone',
    },
    CAMERA: {
      TITLE: 'Acesso à câmera necessário',
      DESCRIPTION: 'Este aplicativo precisa de acesso à sua câmera para funcionar corretamente.',
      INSTRUCTION: 'Por favor, conceda permissão à câmera para continuar usando o aplicativo.',
      BUTTON_LABEL: 'Conceder permissão à câmera',
    },
    NOTIFICATIONS: {
      TITLE: 'Permissão de notificações necessária',
      DESCRIPTION: 'Este aplicativo precisa de permissão para enviar notificações para você.',
      INSTRUCTION: 'Por favor, conceda permissão de notificações para continuar usando o aplicativo.',
      BUTTON_LABEL: 'Conceder permissão de notificações',
    },
    GEOLOCATION: {
      TITLE: 'Acesso à localização necessário',
      DESCRIPTION: 'Este aplicativo precisa de acesso à sua localização para funcionar corretamente.',
      INSTRUCTION: 'Por favor, conceda permissão de localização para continuar usando o aplicativo.',
      BUTTON_LABEL: 'Conceder permissão de localização',
    },
    HEADINGS: {
      WHAT_TO_DO: 'O que você precisa fazer:',
      ADDITIONAL_REQUIRED: 'Permissões adicionais necessárias',
      GENERIC_PERMISSION_TITLE: 'Permissão necessária',
      GENERIC_DESCRIPTION: 'Este aplicativo requer permissões adicionais para funcionar corretamente.',
      GENERIC_INSTRUCTION: 'Por favor, conceda as permissões necessárias para continuar.',
    },
    DEFAULT_BUTTON_LABEL: 'Conceder permissão',
  },
  SETTINGS: {
    TITLE: 'Configurações',
    SUBTITLE: 'Gerencie suas preferências de idioma e tradução',
    LANGUAGE_DISPLAY: 'Idioma de exibição',
    AUTO_TRANSLATE_TITLE: 'Ativar tradução automática',
    AUTO_TRANSLATE_DESCRIPTION: 'Traduza automaticamente as mensagens recebidas para o idioma selecionado.',
    SAVE_BUTTON: 'Salvar',
    SELECT_PLACEHOLDER: 'Selecione uma opção...',
  },
  SOS_MODAL: {
    TITLE_ALERT_TRIGGERED: 'Alerta SOS ativado',
    LOCATION_LABEL: 'Localização',
    INCIDENT_LABEL: 'Incidente',
    LAST_STATUS_LABEL: 'Último status',
    ASSIST_BUTTON: 'Ajudar',
  },
  HEADER: {
    USERNAME: 'Nome de usuário',
    MODE: 'Modo',
    SETTINGS: 'Configurações',
    LOG_OUT: 'Sair',
    TITLE: 'AGIL Field Ops',
  },

  ERRORS: {
    INVALID_CHAT_DATA: 'Dados de chat inválidos',
    SUMMARY_GENERATION_FAILED: 'Falha na geração do resumo:',
    FAILED_TO_GENERATE_SUMMARY: 'Falha ao gerar o resumo.',
    PLEASE_TRY_AGAIN: 'Por favor, tente novamente.',
    UNKNOWN: 'Desconhecido',
    IN_PROGRESS_STATUS_ERROR: 'Pelo menos um respondente deve ser atribuído quando o status for "Em andamento"',
    RESOLVED_STATUS_ERROR: 'Pelo menos um respondente deve ser atribuído antes de encerrar o incidente',
    SELECT_ONE_RESPONDER_ERROR: 'Por favor, selecione pelo menos um respondente',
    WAIT_BEFORE_SUBMIT_AGAIN: 'Por favor, aguarde antes de enviar novamente',
    INCIDENT_CREATION_SERVICE_UNAVAILABLE:
      'O serviço de criação de incidentes não está disponível. Tente novamente mais tarde.',
    NO_CHANGES_TO_UPDATE: 'Nenhuma alteração para atualizar',
    FAILED_TO_UPDATE_INCIDENT: 'Falha ao atualizar o incidente. Verifique sua conexão e tente novamente.',
    FAILED_TO_CREATE_INCIDENT: 'Falha ao criar o incidente. Verifique sua conexão e tente novamente.',
  },

  INCIDENT_TYPES: [
    { value: 'Medical', label: 'Médico' },
    { value: 'Car accident', label: 'Acidente de carro' },
    { value: 'Fire', label: 'Incêndio' },
    { value: 'Patrol', label: 'Patrulha' },
  ],

  SEVERITY_VALUES: [
    { value: 4, label: 'Crítico', dotColor: 'bg-icon-error' },
    { value: 3, label: 'Alto', dotColor: 'bg-chart-2' },
    { value: 2, label: 'Médio', dotColor: 'bg-chart-4' },
    { value: 1, label: 'Baixo', dotColor: 'bg-interactive' },
    { value: 0, label: 'Mínimo', dotColor: 'bg-icon-muted' },
  ],

  INCIDENT_CARD_STATUS_VALUES: [
    { value: 'created', label: 'Criado' },
    { value: 'progress', label: 'Em andamento' },
    { value: 'resolved', label: 'Resolvido' },
  ],

  CREATE_INCIDENT_STATUS_VALUES: [
    { value: 'open', label: 'Criado' },
    { value: 'in_progress', label: 'Em andamento', disabled: false },
  ],

  EDIT_INCIDENT_STATUS_VALUES: [
    { value: 'in_progress', label: 'Em andamento' },
    { value: 'resolved', label: 'Fechado' },
  ],

  INCIDENT_DETAILS_STATUS_VALUES: [
    { value: 'created', label: 'Criado', disabled: true },
    { value: 'progress', label: 'Em andamento', disabled: true },
    { value: 'resolved', label: 'Fechado', disabled: true },
  ],

  RESPONSE_STATUS: [
    { value: 'accepted', label: 'Aceito' },
    { value: 'rejected', label: 'Recusado' },
    { value: 'pending', label: 'Pendente' },
  ],

  ASSIGNEE_STATUS: [
    { value: 'not_started', label: 'Não iniciado' },
    { value: 'on_the_way', label: 'A caminho' },
    { value: 'reach_site', label: 'No local' },
    { value: 'enroute', label: 'A caminho' },
    { value: 'done', label: 'Concluído' },
  ],

  RESPONDER_STATUS: [
    { value: 'Unacknowledged', label: 'Não reconhecido' },
    { value: 'Rejected', label: 'Rejeitado' },
    { value: 'Arrived at scene', label: 'Chegou ao local' },
    { value: 'On the way', label: 'A caminho' },
    { value: 'Aborted', label: 'Abortado' },
    { value: 'Done', label: 'Concluído' },
  ],

  WEEKDAYS: [
    { value: 'Sun', label: 'Dom' },
    { value: 'Mon', label: 'Seg' },
    { value: 'Tue', label: 'Ter' },
    { value: 'Wed', label: 'Qua' },
    { value: 'Thu', label: 'Qui' },
    { value: 'Fri', label: 'Sex' },
    { value: 'Sat', label: 'Sáb' },
  ],
};
